import(/* webpackMode: "eager" */ "/vercel/path0/src/app/layout.js")